const SectionHeader = ({
  icon: Icon,
  title,
  iconClassName,
}: {
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  iconClassName?: string;
}) => {
  return (
    <div className="flex gap-x-1">
      <Icon className={iconClassName ?? "text-fds-tertiary"} />
      <p className="headline-sm">{title}</p>
    </div>
  );
};
export default SectionHeader;
